import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=6453bb6b&scoped=true&"
import script from "./ControlPanel.vue?vue&type=script&lang=js&"
export * from "./ControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanel.vue?vue&type=style&index=0&id=6453bb6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453bb6b",
  null
  
)

export default component.exports